import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    class: "stick-to-right",
    stickyColumn: "",
    style: {
      "right": "0"
    }
  }, {
    default: _withCtx(() => [$props.push_loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_spinner, {
      small: ""
    })])) : _createCommentVNode("", true), !$props.push_loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('onEditSingleItem', $props.item)),
      style: {
        "padding": "8px",
        "cursor": "pointer"
      }
    }, [_createVNode(_component_app_icon, {
      icon: $props.item.sku ? 'edit-new' : 'not-editable',
      id: `${$props.item.content_id}-edit`
    }, null, 8, ["icon", "id"])]), _ctx.isOmnyAdmin || _ctx.isOmnyUser ? (_openBlock(), _createBlock(_component_app_popover, {
      key: 0,
      target: `${$props.item.content_id}-edit`,
      "auto-width": "",
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.testCaseTooltip($props.item)), 1)]),
      _: 1
    }, 8, ["target"])) : _createCommentVNode("", true), !$props.item.sku ? (_openBlock(), _createBlock(_component_app_popover, {
      key: 1,
      target: `${$props.item.content_id}-edit`,
      "auto-width": "",
      placement: "top",
      "custom-class": "not-editable"
    }, {
      default: _withCtx(() => [_createTextVNode(" Assign SKU to the item to start editing the content ")]),
      _: 1
    }, 8, ["target"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
    _: 1
  });
}